module.exports = __webpack_public_path__ + "static/media/logotipo-lux-login.c2616f55.png";